<template> 
	<div class="tabsWrapper" :class="showSlider ? 'tabsWrapper--slider' : ''" :style="{ height: height + 'px' }" ref="tabsWrapper">
		<div v-if="showSlider && offsetSlider < 0" @click="slide('left')" class="previous" :style="{ height: height + 'px'}">
			<div>&lt;</div>
		</div>
		<div v-if="showSlider && showNext" class="next"  @click="slide('right')" :style="{ height: height + 'px'}">
			<div>&gt;</div>
		</div>
		<div class="tabs" :class="['tabs--' + level, allowWrap ? 'tabs--wrap' : '']" ref="tabsList" :style="{ left: offsetSlider + 'px'}">
			<div v-for="view in views.list" class="tab" :style="{flexBasis: tabWidth + 'px'}" :class="[view.inactive ? 'tab--inactive' : '', view.code == activeView.code ? 'tab--active' : '']" @click="!view.inactive ? change(view) : ''" :key="view.code" ref='tabs'>
				{{view.wording}}
			</div>
			<template v-if="allowWrap">
				<div v-for="i in 4" :key="'tabfiller-' + i" class="tab tab--filler" :style="{flexBasis: tabWidth + 'px'}">
				</div>
			</template>
		</div>
	</div>
</template> 
<script>
	export default {
		name: 'Tabs',
		props: {
			level: {
				type: String,
				default: 'primary',
			},
			views: Object,
			activeView: Object,
			tabWidth: {
				type: Number, 
				default: 175,
			},
			allowWrap: {
				type: Boolean,
				default: false,
			},
			enableSlider: {
				type: Boolean,
				default: false,
			},
			height: {
				type: Number,
				default: 50,
			}
		},
		data: function() {
			return {
				showSlider: false,
				offsetSlider: 0,
				showNext: true,
			}
		},
		mounted() {
			if (this.enableSlider) {			
				this.$nextTick(function() {
					let availableWidth = this.$refs.tabsList.getBoundingClientRect().width
					let tabsWidth = this.tabWidth * this.$refs.tabs.length
					if (tabsWidth > availableWidth) this.showSlider = true
				})
			}
		},
		methods: {
			change: function(view) {
				this.$emit('change', view)
			},
			slide: function(direction) {
				if (direction == 'left') this.offsetSlider += this.tabWidth
				if (direction == 'right') this.offsetSlider -= this.tabWidth
				this.$nextTick(function() {
					let inside = this.$refs.tabsList.scrollWidth
					let outside = this.$refs.tabsWrapper.getBoundingClientRect().width
					this.showNext = inside + this.offsetSlider >= outside
				})
			}
		},
		computed: {

		},
	}
</script>
<style scoped lang="scss">
@import '../css/contexte.apps.colors';
@import '../css/contexte.apps.fonts';
.tabs {
	&Wrapper {
		margin-bottom: 1em;	
		&--slider {
			position: relative; 
			overflow: hidden;
			.tabs {
				margin-bottom: 0;
				position: absolute;
				top: 0;
			}
			.tab {
				margin-bottom: 0;
				flex-grow: 0;
				flex-shrink: 0;
			}
		}
	}
	display: flex;
	margin-bottom: 1em;
	&--wrap {
		flex-wrap: wrap;
		margin-bottom: 0;
		.tab {
			flex-grow: 1;
			margin-bottom: 1.8em;
			max-width: 250px;
		}
	}
	&--secondary {
		width: calc(100% + 10px);
		margin-left: -5px;
		margin-right: -5px;
		.tab {
			margin-left: 5px;
			margin-right: 5px;
			font-size: .75em;
			border-top: 2px solid $light-grey;
			padding-top: .6em;
			text-transform: uppercase;
			display: block;
			max-width: 175px;
			&--active {
				border-color: $dark-grey;
			}
			&:not(.tab--active):not(.tab--inactive) {
				&:hover {
					border-color: $medium-grey;
					text-decoration: none;
				}
			}
		}
	}
}
.tab {
	flex: 0 1 100px; 
	padding: 8px 25px 0 0;
	display: flex;
	border-top: 1px solid $light-grey;
	color: $another-grey;
	font: 400 1em/125% $sans;
	position: relative;
	&:not(.tab--active):not(.tab--inactive) {
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
	&--filler {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
		height: 0 !important;
		max-height: 0 !important;
		min-height: 0 !important;
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		border: none !important;
	}
	&--active {
		font-weight: 600;
		border-color: $another-grey;
		border-width: 3px;
		color: $dark-grey;
		padding-top: 6px;
	}
	&--inactive {
		opacity: 0.4;
		cursor: default;
	}
}
.next, .previous {
	position: absolute;
	width: 40px;
	z-index: 2;
	display: flex;
	align-items: center;
	div {
		font-size: 1.1em;
		transform: scaleY(1.6);
	}
}
.previous {
	justify-content: flex-start;
	background: linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,1) 100%);
	left: 0;
}
.next {
	background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,1) 100%);
	justify-content: flex-end;
	right: 0;
}
@media screen and (max-width: 600px)  {
	.tabs {
		&--wrap {
			.tab {
				margin-bottom: 1.8em;
			}
		}
	}
}
</style>